// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import type { SymbolGlyphProps } from './glyph';
import { MachineLetter, RotatingMachine } from './RotatingMachine';

/**
 * Motor — a rotating machine, lettered `M`. IEC 60617 / IEEE 315.
 *
 * The chillers, towers and condensing units on the mechanical board draw as
 * this: no one-line standard has a chiller symbol, and to the switchboard each
 * is a compressor motor. Pumps and fans have their own marks (`PumpSymbol`,
 * `FanSymbol`) and share this frame.
 */
export const MotorSymbol = ({ size = 18, run, leads }: SymbolGlyphProps) => (
  <RotatingMachine size={size} run={run} leads={leads}>
    <MachineLetter letter="M" />
  </RotatingMachine>
);
